module.exports = __webpack_public_path__ + "static/media/default-coach.befc6d01.png";